import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  addToSharedCache
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Add a project team member
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestCreateInformation = packet => {
  return {
    type: 'REQUEST_CREATE_INFORMATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCreateInformationSuccess = data => ({
  type: 'RECEIVE_CREATE_INFORMATION_SUCCESS',
  data
})

export const receiveCreateInformationFail = data => ({
  type: 'RECEIVE_CREATE_INFORMATION_FAIL',
  data
})

export const tryToCreateInformation = (packet, callback) => (dispatch, getState) => {

  dispatch(requestCreateInformation(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/information/' + packet.knowledge_id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveCreateInformationSuccess(json));

      dispatch(addToSharedCache({
        path: 'knowledge/' + packet.knowledge_id + '/info',
        item: json.data
      }))
      
      if(!packet.noPush){
        dispatch(push('/workbench/' + packet.scope + '/knowledge/' + packet.knowledge_id + '/info/' + json.data.id))
      }


      if(callback) callback(null, json);
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveCreateInformationFail({errors:e, lastSubmit: packet}));
      if(callback) callback({errors:e, lastSubmit: packet});
    })
}
